"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _nano = require("./nano");
var selectBoxStyles = {
  select: {
    display: 'flex',
    justifyContent: 'center',
    minWidth: '100px',
    minHeight: '25px',
    padding: '5px',
    border: 'none',
    cursor: 'pointer',
    boxSizing: 'content-box'
  }
};
var _default = exports["default"] = (0, _nano.sheet)(selectBoxStyles);